// /**
//  * Create and Edit from Center
//  */

import React, { useState, useEffect } from 'react'

// components
import { useForm } from 'react-hook-form'
import { isEmpty } from 'lodash'
import DimensionInputs from '../../components/sections/crossdoc/DimensionInputs'
import ContactList from '../../components/lists/contactList'

// UI
import {
  Grid,
  Button,
  Typography,
  Dialog,
  DialogContent
} from '@material-ui/core'
import jMoment from 'moment-jalaali'
import classes from './index.module.scss'

// Type
import { ParcelItems, PayloadCreate } from '../parcelsSender/interfaces'

// helpers'
import {
  removeEmptyValueObject,
  convertPersianDigit2English
} from '../../utils/helpers'

import { useHistory } from 'react-router-dom'
import handleNotification from '../../utils/handleNotfication'
import handleError from '../../utils/handleError'
import {
  createOrderItemsPayload,
  Order,
  OrderItems,
  UpdateOrderPayload
} from '../orders/interfaces'
import CustomerInfo from '../../components/sections/createOrder/customerInfo'

import OrderInputs from '../../components/inputs/crossdocOrderInputs'
import ConfirmModal from '../../components/Modal/confirm'
import ordersRepository from 'client-sdk/src/Repository/orders-repository'
import RonadIcons from '../../components/iconComponent'

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true })

type Props = {
  create: (body: any) => void
  onClose: () => void
  warehouseId: number
  createParcelsDispatch: (payload: PayloadCreate) => void
  getOrderDispatch: (payload: { id: number }) => void
  orderItemsList?: OrderItems[]
  getOrderItemsDispatch: (payload: any) => void
  createOrderItemDispatch: (payload: createOrderItemsPayload) => void
  updateOrderDispatch: (payload: UpdateOrderPayload) => void
  clearOrderDispatch: () => void
  order: Order
  match: any
}

type Inputs = {
  agentName: string
  agentPhoneNumber: string
  deliveryDate: string | Date | null
  destinationId: number
  orderType: string | null
  orderTplType: string
  id: number
  origin: string | number
  paymentType: string
  destination: string
  customerName: string
  customerNationalCode: string
  customerMobileNumber: string
  customerPhoneNumber: string
  customerProvince: any
  customerCity: string
  customerZipCode: string
  deliveryType: string
  trackingCode: string
  customerAddress: string
  description: string
  items: ParcelItems[]
  deliveryTime: string | null
  deliveryStartTime: string | null
  deliveryEndTime: string | null
  centerId: number | null | string
  fulfillmentTypeId: number | null | string
  courierId: number | null | string
  cutoffId: number | null | string
  cost: string
  weight: string
  orderValue: string
  packageCode: string
  senderName: string
  deliveryCode: string
  codPaymentCode: string
  packageCount: string
  location: Location
}

type Location = {
  lat: number | null
  lng: number | null
}

function CrossDoc(props: Props) {
  const history = useHistory()
  const form = useForm<Inputs>({
    defaultValues: {
      orderType: 'WITHOUT_CENTER',
      orderTplType: 'RONAD',
      deliveryDate: null,
      deliveryTime: '',
      deliveryStartTime: null,
      deliveryEndTime: null,
      centerId: '',
      fulfillmentTypeId: '',
      courierId: '',
      cutoffId: '',
      origin: '',
      destination: '',
      customerName: '',
      customerNationalCode: '',
      customerMobileNumber: '',
      customerPhoneNumber: '',
      customerProvince: '',
      customerCity: '',
      customerZipCode: '',
      deliveryType: '',
      trackingCode: '',
      customerAddress: '',
      description: '',
      cost: '',
      weight: '',
      senderName: '',
      packageCount: '',
      paymentType: '',
      orderValue: '',
      packageCode: '',
      deliveryCode: '',
      codPaymentCode: '',
      location: {
        lat: null,
        lng: null
      }
    }
  })

  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset
  } = form

  const partnerId = Number(localStorage.getItem('partnerId'))
  const [invoiceLink, setInvoiceLink] = useState<any>('')
  const [notifType, setNotifType] = useState('')
  const [dialog, setDialog] = useState<string>('')
  const [itemsInfo, setItemsInfo] = useState<any>([])
  const [location, setLocations] = useState<Location | undefined>({
    lat: 0,
    lng: 0
  })
  const [formData, setFormData] = useState<any>(null)
  const [orderId] = useState<number>(props.match.params.id)
  const [editMode, setEditMode] = useState(false as boolean)
  const [order, setOrder] = useState<Order>({})
  const [orderItems, setOrderItems] = useState()
  const [submitLoading, setSubmitLoading] = useState(false)
  const [dimensions, setDimensions] = useState([])
  const [deliveryTime, setDeliveryTime] = useState('')
  const [orderPackages, setOrderPackages] = useState<any>()
  const [orderValue, setOrderValue] = useState('')
  const [orderPaymentType, setOrderPaymentType] = useState('')
  const [deliveryServiceId, setDeliveryServiceId] = useState()

  useEffect(() => {
    if (orderId) {
      setEditMode(true)
    }
  }, [])

  useEffect(() => {
    if (editMode) {
      getOrder({ id: orderId })
      getOrderItems({ 'orderId.equals': orderId, size: 1000 })
    }
  }, [editMode])

  useEffect(() => {
    if (!isEmpty(order)) {
      const {
        orderType,
        centerId,
        fulfillmentTypeId,
        courierId,
        cutoffId,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        description,
        customerLat,
        customerLon,
        paymentType,
        orderValue,
        deliveryCode,
        codPaymentCode,
        orderTPLType,
        senderName,
        orderPackages
      } = order

      const payload = {
        orderType,
        deliveryDate,
        deliveryStartTime: deliveryDate + ' ' + deliveryStartTime,
        deliveryEndTime: deliveryDate + ' ' + deliveryEndTime,
        deliveryTime: `${deliveryStartTime?.substring(
          0,
          2
        )}-${deliveryEndTime?.substring(0, 2)}`,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        paymentType,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        centerId,
        fulfillmentTypeId,
        courierId,
        senderName,
        cutoffId,
        description,
        destination: null,
        packageCount: orderPackages[0].packageCount,
        weight: orderPackages[0].totalWeight,
        orderValue,
        isChangedReceiptFile: false,
        packageCode: orderPackages[0].packageCode,
        orderTplType: orderTPLType ? orderTPLType : 'RONAD',
        deliveryCode,
        codPaymentCode
      }

      const location = {
        lat: Number(customerLat),
        lng: Number(customerLon)
      }
      if (location.lat && location.lng) {
        handleLocations(location)
      }
      setOrderValue(orderValue)
      reset(payload)
    }
  }, [order])

  useEffect(() => {
    if (editMode && orderItems) {
      setItemsInfo(orderItems)
    }
  }, [orderItems])

  useEffect(() => {
    if (getValues('deliveryType') == 'COURIER') {
      setNotifType('COURIER')
    } else {
      setNotifType('')
    }
  }, [getValues('deliveryType')])

  const onSubmit = (data: Inputs) => {
    if (editMode) {
      setFormData(data)
      setDialog('confirmationOrder')
      return
    }
    setFormData(data)
    setDialog('confirmationOrder')
  }
  const handleLocations = (data: { lat: number; lng: number }) => {
    setLocations(data)
  }

  useEffect(() => {
    if (editMode) {
      setDimensions(order.orderPackages)
    }
  }, [order])

  useEffect(() => {
    if (!editMode) {
      const filteredPackages = dimensions.map(
        ({ totalWeight, packageCode }) => ({
          totalWeight,
          packageCode
        })
      )
      setOrderPackages(filteredPackages)
    }
  }, [dimensions])

  const handleSubmitOrder = async () => {
    try {
      const {
        deliveryDate: deliver,
        weight,
        packageCode,
        packageCount,
        fulfillmentTypeId,
        paymentType,
        centerId,
        cutoffId,
        courierId,
        origin,
        senderName
      } = formData

      if (deliver.date) {
        var deliveryDate = convertPersianDigit2English(
          deliver.format('YYYY-MM-DD')
        )
      } else {
        var deliveryDate = deliver
      }
      const payload = {
        fulfillmentTypeId,
        partnerId,
        centerId,
        cutoffId,
        courierId,
        senderName,
        orderType: 'FROM_CENTER',
        origin: editMode ? origin : 'FROM_CENTRE',
        paymentType: editMode ? orderPaymentType : paymentType,
        orderValue,
        deliveryServiceId,
        deliveryDate,
        deliveryStartTime: convertPersianDigit2English(
          deliveryTime.substring(0, 2).concat(':00:00')
        ),
        deliveryEndTime: convertPersianDigit2English(
          deliveryTime.substring(3, 5).concat(':00:00')
        ),
        items: [],
        id: editMode ? +orderId : undefined,
        orderPackages: orderPackages,
        weight,
        packageCount,
        packageCode,
        isChangedReceiptFile: ''
      }
      const files = new FormData()
      files.append('receiptFile', new Blob(['']))
      files.append('labelFile', new Blob(['']))

      if (editMode) {
        const body = new Blob(
          [
            JSON.stringify({
              ...removeEmptyValueObject(payload),
              ...removeEmptyValueObject(collectCustomerInfo())
            })
          ],
          {
            type: 'application/json'
          }
        )
        files.append('updateOrderDTO', body)

        updateOrder(files)
      } else {
        const body = new Blob(
          [
            JSON.stringify({
              ...payload,
              ...removeEmptyValueObject(collectCustomerInfo())
            })
          ],
          {
            type: 'application/json'
          }
        )
        files.append('createOrderDTO', body)
        createOrder(files)
      }
    } catch (err: any) {
      handleError(err)
    }
  }

  const collectCustomerInfo = () => {
    const {
      customerAddress,
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerProvince,
      customerZipCode,
      description,
      trackingCode
    } = formData
    return {
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode: customerNationalCode || '1111111111',
      customerPhoneNumber: '02177777777',
      customerProvince,
      customerZipCode: customerZipCode || '1111111111',
      deliveryType: 'COURIER',
      description,
      receiptUrl: invoiceLink,
      trackingCode,
      customerLat: location?.lat,
      customerLon: location?.lng,
      customerAddress
    }
  }

  const createOrder = async (body: any) => {
    try {
      setSubmitLoading(true)
      await ordersRepository.createOrder({ payload: { body } })
      handleNotification('سفارش شما با موفقیت ثبت گردید.', 'success')
      setSubmitLoading(false)
      history.push('/orders')
    } catch (err: any) {
      setSubmitLoading(false)
      if (
        err.response?.status == 400 &&
        err.response.data.fieldErrors?.length > 0
      ) {
        err.response.data.fieldErrors.forEach((el: any) => {
          handleNotification(`مقدار فیلد ${el.field} اشتباه است`, 'error')
        })
      } else if (
        err.response?.status == 406 &&
        err.response.data.errorKey == 'OrderItem.SkuId.not_acceptable'
      ) {
      } else if (err.response?.status == 409) {
        handleNotification(`مقدار فیلد کد رهگیری تکراری است`, 'error')
      } else {
        handleError(err)
      }
    }
  }

  const updateOrder = async (body: any) => {
    try {
      setSubmitLoading(true)
      await ordersRepository.newUpdateOrder({ payload: { body } })
      handleNotification('سفارش شما با موفقیت ویرایش گردید.', 'success')
      setSubmitLoading(false)
      history.push('/orders')
    } catch (error) {
      setSubmitLoading(false)
      handleError(error)
    }
  }

  const getOrder = async (payload: any) => {
    try {
      const response = await ordersRepository.getOrderWithId({ payload })
      setOrder(response.data)
    } catch (error) {
      handleError(error)
    }
  }

  const getOrderItems = async (payload: any) => {
    try {
      const response = await ordersRepository.getAllOrderItems({ payload })
      setOrderItems(response.data)
    } catch (error) {
      handleError(error)
    }
  }

  const onSelectContact = (contact: any) => {
    setValue('customerName', contact.fullName)
    setValue('customerProvince', contact.province)
    setValue('customerCity', contact.city)
    setValue('customerMobileNumber', contact.mobile)
    setValue('customerAddress', contact.address)
    setValue('customerZipCode', contact.postalCode ? contact.postalCode : '')
    setValue(
      'customerNationalCode',
      contact.nationalCode ? contact.nationalCode : ''
    )
    setLocations({
      lat: contact.lat,
      lng: contact.lon
    })
    setDialog('')
  }
  const onContactDelete = (e: any, id: string) => {
    e.preventDefault()
    e.stopPropagation()
    setSelected(id)
    setDialog('DELETE')
  }

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid lg={12} md={12} container style={{ width: '100%' }}>
          <div
            style={{
              backgroundColor: '#fff',
              padding: '24px',
              borderRadius: '4px',
              width: '100%'
            }}
          >
            <Typography
              variant='h6'
              component='h2'
              style={{ fontWeight: 'bold', marginBottom: '20px' }}
            >
              اطلاعات سفارش
            </Typography>
            <OrderInputs
              editMode={editMode}
              form={form}
              setOrderValue={setOrderValue}
              orderValue={orderValue}
              setDeliveryTime={setDeliveryTime}
              setOrderPaymentType={setOrderPaymentType}
              setDeliveryServiceId={setDeliveryServiceId}
            />
            <div style={{ display: 'flex' }}>
              <Typography
                variant='h6'
                component='h2'
                style={{ fontWeight: 'bold' }}
              >
                اطلاعات ارسال
              </Typography>
              <RonadIcons
                name='addressBook'
                style={{ marginRight: '5px', color: '#f39869' }}
                size={1.3}
                onClick={() => setDialog('CONTACTS')}
              />
            </div>
            <CustomerInfo
              form={{
                errors,
                watch,
                setValue,
                getValues,
                register,
                control
              }}
              handleLocations={handleLocations}
              location={location}
            />

            <Typography className={classes.typographyCards}>
              بسته های سفارش
            </Typography>
            <DimensionInputs
              setDimensions={setDimensions}
              dimensions={dimensions}
              editMode={editMode}
            />
            <Grid container justifyContent='flex-end'>
              <Button
                type='submit'
                size='medium'
                variant='contained'
                color='primary'
                style={{
                  marginRight: '14px'
                }}
                data-cy='saveOrder'
              >
                {editMode ? 'ویرایش سفارش' : 'ایجاد سفارش'}
              </Button>
            </Grid>
          </div>
        </Grid>
      </form>
      <ConfirmModal
        open={dialog === 'confirmationOrder'}
        onClose={() => setDialog('')}
        onSubmit={handleSubmitOrder}
        loading={submitLoading}
      >
        <Typography variant={'h6'}>
          {`آیا از ${editMode ? 'ویرایش' : 'ایجاد'} سفارش ${
            editMode ? orderId : 'جدید'
          } مطمئن هستید؟`}
        </Typography>
      </ConfirmModal>

      <Dialog
        open={dialog === 'CONTACTS'}
        fullWidth
        onClose={() => setDialog('')}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent
          style={{
            width: '100',
            marginBottom: '16px',
            minHeight: '500px',
            maxHeight: '500px'
          }}
        >
          <ContactList onDelete={onContactDelete} onSelect={onSelectContact} />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default CrossDoc
